(function($) {
    const accordion = () => {
        const $accordion = $('.accordion')

        $accordion.each(function() {
            const $this = $(this)
            const $header = $this.find('.accordion-header')
            const $content = $this.find('.accordion-content')
            
            $header.on('click', (e) => {
                if (e.target.tagName !== 'A') {
                    const colClass = 'accordion-collapsed'
                    const expClass = 'accordion-expanded'
                    $content.slideToggle()
                    $this.hasClass('accordion-collapsed') 
                        ? $this.removeClass(colClass).addClass(expClass) 
                        : $this.removeClass(expClass).addClass(colClass) 
                }
            })
        })
    }

    $(function() {
        accordion()
    })
})(jQuery);
